// LazySection.jsx
import React from 'react';
import { useInView } from 'react-intersection-observer';

const LazySection = ({ id, children }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1, // Render when 20% visible
    });

    return (
        <div
            id={id} // <-- now id is attached to DOM
            ref={ref}
            style={{
                minHeight: '100px',
                scrollMarginTop: '150px', // adjust for sticky header height
            }}
        >
            {inView ? children : null}
        </div>
    );
};

export default LazySection;
